import React from "react";

const Loading = ({ count, refLoading }) => {
  return (
    <div ref={refLoading} className="loading">
      <div className="container">
        <span>{count}%</span>
        <div className="bar">
          <div className="progress" style={{ width: count + "%" }}></div>
        </div>
        <p>Chargement des images</p>
      </div>
    </div>
  );
};

export default Loading;
